import { render, staticRenderFns } from "./model-leftMenu.vue?vue&type=template&id=0bf2ee0b&scoped=true&"
import script from "./model-leftMenu.vue?vue&type=script&lang=js&"
export * from "./model-leftMenu.vue?vue&type=script&lang=js&"
import style0 from "./model-leftMenu.vue?vue&type=style&index=0&id=0bf2ee0b&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf2ee0b",
  null
  
)

export default component.exports